import React, { Component } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "../components/DateRangePicker.scss";

class DateRangePicker extends Component {
  onChangedStartDate = startDate => {
    this.props.onChange({ startDate, endDate: this.props.endDate });
  };
  onChangedEndDate = endDate => {
    this.props.onChange({ startDate: this.props.startDate, endDate });
  };

  render() {
    return (
      <div className="DateRangePicker" style={this.props.style}>
        <DatePicker
          selected={this.props.startDate}
          dateFormat="D.M.Y"
          selectsStart
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onChange={this.onChangedStartDate}
        />-
        <DatePicker
          selected={this.props.endDate}
          dateFormat="D.M.Y"
          selectsEnd
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          onChange={this.onChangedEndDate}
        />
      </div>
    );
  }
}

export default DateRangePicker;



// WEBPACK FOOTER //
// ./src/components/DateRangePicker.js